import { withInstall, withNoopInstall } from "@xplus/utils/with-install";
import steps from "./src/steps.vue";
import step from "./src/step.vue";
export const xSteps = withInstall(steps, { step });
export default xSteps;
export const xStep = withNoopInstall(step);
export * from "./src/step";
export * from "./src/steps";
